var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"500px"}},[_c('ImageMockup',{attrs:{"mockup-img-src":require('@/assets/images/mockups/print/print_mockup.png'),"product-image-corners":[
            [0.3262, 0.1745],
            [0.873, 0.1752],
            [0.8446, 0.7071],
            [0.2971, 0.6941],
        ]}},[_c('PrintPreview',{attrs:{"use-aspect-ratio":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }